import FilterPicker from './FilterPickerLocal'

export default FilterPicker;